module Meevo.Plugins.YieldManagementProgram {

    enum EAdjustmentTypes {
        Currency,
        Percent
    }

    class DayTimeAdjustment implements ng.IComponentController {

        static $inject = [
            '$scope',
            '$translate',
            '$locale',
            'meevo.components.common.IdentityService',
        ];

        get isPercent() {
            return [
                ProgramAdjustmentOverrideEnum.DecreasePercent,
                ProgramAdjustmentOverrideEnum.IncreasePercent
            ].indexOf(this.model.programAdjustmentOverride) !== -1
        }

        set isPercent(value) {
        }

        get allowToDelete() {
            return this.isHomeLocation
              || (!this.isHomeLocation && this.model.locationId && this.row.adjustments.length > 1);
        }

        get showRevertButton() {
            return !this.isHomeLocation
              && this.row.adjustments.length === 1;
        }

        disabled: boolean;
        model: ProgramTimeRange;
        adjustmentTypes: EAdjustmentTypes;
        adjustmentsOverrideTypes: { displayName: string; value: ProgramAdjustmentOverrideEnum }[];
        row: IDayTimeAdjustmentsRow;
        afterDelete: () => void;
        change: () => void;
        allAdjustments: ProgramTimeRange[];
        program: YMProgramModel;
        isHomeLocation: boolean;
        hasParent: boolean;

        constructor(private $scope: ng.IScope,
                    private $translate: ng.translate.ITranslateService,
                    private $locale: ng.ILocaleService,
                    private identityService: Meevo.Components.Common.IIdentityService) {
            this.adjustmentsOverrideTypes = [
                {
                    displayName: $translate.instant('LABEL_TYPE_DECREASE', { type: '%' }),
                    value: ProgramAdjustmentOverrideEnum.DecreasePercent
                },
                {
                    displayName: $translate.instant('LABEL_TYPE_DECREASE', { type: this.$locale.NUMBER_FORMATS.CURRENCY_SYM }),
                    value: ProgramAdjustmentOverrideEnum.DecreaseAmount
                },
                {
                    displayName: $translate.instant('LABEL_TYPE_INCREASE', { type: this.$locale.NUMBER_FORMATS.CURRENCY_SYM }),
                    value: ProgramAdjustmentOverrideEnum.IncreaseAmount
                },
                {
                    displayName: $translate.instant('LABEL_TYPE_INCREASE', { type: '%' }),
                    value: ProgramAdjustmentOverrideEnum.IncreasePercent
                },
            ];
        }

        $onInit() {
            this.isHomeLocation = this.program.homeLocationId === this.identityService.current().locationId;
        }

        checkValidation() {
            if (typeof this.change === 'function') {
                this.change();
            }
        }

        removeAdjustment() {
            if (this.disabled) return;

            this.row.adjustments.splice(
                this.row.adjustments.indexOf(this.model), 1
            );

            this.revertCOAdjustments();

            this.afterDelete();
        }

        revertCOAdjustments() {
            if (this.row.adjustments.length === 0 && !this.isHomeLocation) {
                this.row.adjustments.push(
                  ...this.allAdjustments
                    .filter((adjustment) => adjustment.dayOfWeek === this.row.id && !adjustment.locationId)
                    .map((adjustment) => {

                        return new ProgramTimeRange({
                            ...adjustment,
                            locationId: this.identityService.current().locationId
                        });
                    })
                );
            }
        }
    }

    angular.module('meevo.plugins.yieldManagementProgram')
        .component('ypDayTimeAdjustment', {
            templateUrl: 'app/plugins/yieldManagementProgram/components/day-time-adjustment/day-time-adjustment.html',
            bindings: {
                row: '=',
                model: '=ngModel',
                disabled: '=ngDisabled',
                afterDelete: '&',
                change: '&ngChange',
                modelCreatedInCurrentLocation: '=',
                allAdjustments: '<',
                program: '<'
           },
            controller: DayTimeAdjustment
        });
}
